/**
 * LoadingSpinner - Wrapper Component
 *
 * This component wraps the design system Spinner component
 * to maintain backward compatibility with existing code.
 *
 * @deprecated Use Spinner from @/design-system instead
 */

import React from 'react';
import { Spinner } from '../../design-system';

const LoadingSpinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  text = ''
}) => {
  // Note: The 'color' prop is ignored as the design system Spinner
  // only supports the primary color. This maintains API compatibility
  // but uses the improved design system component internally.

  return <Spinner size={size} text={text} className={className} />;
};

export default LoadingSpinner;